import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';

import { Scatter } from 'react-chartjs-2';

import {
  formatThousands,
  getColorForCondifence,
} from '../../util';

class Insights extends Component {

  getLargestDealSize(){
    const { deals } = this.props;

    const dealsSortedBySize = _.sortBy(deals, deal => {
      return -1 * deal.estimatedValue
    });

    const largestDealSize = (dealsSortedBySize[0] || {}).estimatedValue || 0;

    return largestDealSize;
  }
  getMappedDealData(){
    const { deals } = this.props;

    const largestDealSize = this.getLargestDealSize();

    return _.map(deals, deal => {

      const confidence = deal.completion.confidence;
      const size = deal.estimatedValue;

      return {
        label: deal.name,
        color: getColorForCondifence(confidence),
        radius: 4 + (size / largestDealSize) * 16,
        point: {
          x: confidence,
          y: size,
        },
        id: deal._id,
      }
    });
  }

  getDataForChart(){

    const dealData = this.getMappedDealData();

    const data = {
      labels: _.map(dealData, 'label'),
      datasets: [{
        label: 'Open deals',
        pointBackgroundColor: _.map(dealData, 'color'),
        pointRadius: _.map(dealData, 'radius'),
        pointHoverBackgroundColor: _.map(dealData, 'color'),
        pointHoverRadius: _.map(dealData, 'radius'),
        pointHoverBorderColor: _.map(dealData, 'color'),

        pointBorderWidth: 0,
        pointHoverBorderWidth: 0,
        label: 'Open Deals',
        data: _.map(dealData, 'point'),
      }]
    };

    return data;
  }
  getOptionsForChart(){
    const options = {
      legend: {
        display: false
      },
      maintainAspectRatio: false,
      onHover: (e, chartElements) => {
        const el = document.getElementById('deal-value-confidence-scatter');
        el.style.cursor = chartElements[0] ? 'pointer' : 'default';
      },
      tooltips: {
        enabled: true,
        titleFontFamily: 'Cabin',
        titleFontSize: 16,
        bodyFontFamily: 'Cabin',
        bodyFontSize: 14,
        footerFontFamily: 'Cabin',
        footerFontSize: 12,
        xPadding: 20,
        yPadding: 20,
        cornerRadius: 5,
        displayColors: false,

        callbacks: {
          title: (tooltipItem, data) => {
            return data.labels[tooltipItem[0].index] || '?';
          },
          label: (tooltipItem, data) => {

            const dealData = data.datasets[0].data[tooltipItem.index] || {};
            const confidence = dealData.x;
            const value = dealData.y;

            return `Confidence: ${confidence}%   Value: $${formatThousands(value)}`;
          },
          footer: (tooltipItem, data) => {
            return 'Click to view deal';
          }
        }
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom',
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 100,
            stepSize: 20,
            callback: (value, index, values) => {
              return `${value}%`;
            }
          },
          scaleLabel: {
            display: true,
            labelString: 'Deal Confidence',
            fontSize: 16,
            fontColor: '#545B72',
            padding:8,
          },
          gridLines: {
            drawBorder: true,
            drawOnChartArea: false,
          },
        }],
        yAxes: [{
          ticks: {
            //maxTicksLimit: 5,
            min: 0,
            max: this.getLargestDealSize() * 1.2,
            callback: (value, index, values) => {
              return `$${formatThousands(value)}`;
            }
          },
          scaleLabel: {
            display: true,
            labelString: 'Deal Size',
            fontSize: 16,
            fontColor: '#545B72',
            padding:8,
          },
          gridLines: {
            drawBorder: true,
            drawOnChartArea: false,
          },
        }]
      }
    }

    return options;
  }

  handleElementClick(element){
    console.log('handling element click: ', element);

    if(!element[0]){
      return;
    }

    const matchingDeal = this.getMappedDealData()[element[0]._index];

    this.props.onDealClick(matchingDeal.id);
  }

  render(){

    const data = this.getDataForChart();
    const options = this.getOptionsForChart();

    //console.log('data for chart: ', data);

    return (
      <div className="deal-insights">
        <Scatter
          id="deal-value-confidence-scatter"
          data={data}
          options={options}
          height={475}
          getElementAtEvent={this.handleElementClick.bind(this)}
        />
      </div>
    );
  }
}

export default Insights;



// WEBPACK FOOTER //
// ./src/components/deals/insights.js